import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Send = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 20 20'
    >
      <path
        fill={primaryColorToUse}
        fillRule='evenodd'
        d='M18.922 1.077a.83.83 0 0 1 .198.865l-5.834 16.666a.833.833 0 0 1-1.548.064l-3.203-7.208-7.207-3.203a.833.833 0 0 1 .063-1.548L18.058.88a.83.83 0 0 1 .864.197m-8.762 9.94 2.248 5.057L16.34 4.838zm5.002-7.358L3.926 7.592l5.056 2.247z'
        clipRule='evenodd'
      />
    </svg>
  );
};
